module.exports = __webpack_public_path__ + "static/media/sport-unscratched.8ac4cbda.jpg";